export var nestedCondition = function (condition, truthy, falsy) { return (condition ? truthy : falsy); };
export var setFocus = function (focusRef) {
    var TIMEOUT_DURATION = 0;
    setTimeout(function () {
        if (focusRef.current) {
            focusRef.current.focus();
        }
    }, TIMEOUT_DURATION);
};
// this exports were added since cy.spy does not support ES modules
export var helpers = {
    setFocus: setFocus
};
